<template>
<div class="pure-u-1 pure-u-md-5-6 pure-u-lg-3-4 pure-u-xl-2-3 container">

  <app-header></app-header>
  <Calendar v-if="isCalendarVisible"
    :year="calendarYear" :month="calendarMonth" v-on:updateMonthYear="updateMonthYear"
    v-on:selectDate="selectDate" />

  <Note :year="year" :month="month" :date="date" />

</div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
import appHeader from "@/components/Header";
import Calendar from "@/components/Calendar";
import Note from "@/components/Note";
import calendarMixin from "@/mixins/calendar";


export default {
  name: "note-page",
  data() {
    return {
    };
  },
  props: ["yearParam", "monthParam", "dateParam"],
  computed: {
    year() {
      return Number(this.yearParam);
    },
    month() {
      return Number(this.monthParam);
    },
    date() {
      return Number(this.dateParam);
    },
    title() {
      return `${this.year} - ${this.month} - ${this.date}`;
    },
    ...mapGetters([
      "user",
      "isCalendarVisible",
    ]),
    ...mapGetters({
      calendarMonth: "month",
      calendarYear: "year",
    }),
  },
  mixins: [calendarMixin],
  created() {
    this.updateMonthYear({ year: this.year, month: this.month });
    this.updateDate({ year: this.year,
      month: this.month,
      date: this.date });
  },
  components: {
    Note,
    appHeader,
    Calendar,
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// NotePage.vue?957d4470